import { environmentURLs } from '../components/common/CaptureEnvironment';
console.log(environmentURLs.REACT_APP_ENV);

export default {
  env: environmentURLs.REACT_APP_ENV,
  serviceEndpoints: {
    consent: environmentURLs.REACT_APP_CONSENT_SERVICE_URL,
    graphQl: environmentURLs.REACT_APP_CONSENT_GRAPH_URL,
    authorize: environmentURLs.REACT_APP_AUTHORIZE_URL,
    organizationUrl: environmentURLs.ORGANIZATION_URL,
    mpDpMetadataUrl: environmentURLs.REACT_APP_MP_DP_METADATA_URL
  },
  url: {
    marketplace: environmentURLs.REACT_APP_MARKETPLACE_URL,
    home: environmentURLs.REACT_APP_MARKETPLACE_URL,
    forgetPassword: environmentURLs.FORGET_PASSWORD_LINK,
    dealersuite: environmentURLs.REACT_APP_DEALERSUITE_URL,
    subscriptionUrl: environmentURLs.REACT_APP_API_SUBSCRIPTION_URL
  },
  footer: {
    social: [
      {
        code: 'facebook',
        url: 'https://www.facebook.com/groups/551215795213352/?source_id=180950569178220' // prettier-ignore
      },
      {
        code: 'twitter',
        url: 'https://twitter.com/fortellisdev'
      },
      {
        code: 'github',
        url: 'https://github.com/fortellis'
      },
      {
        code: 'youtube',
        url: 'https://www.youtube.com/channel/UCk4etySO7-MJhYCPNDtox2A'
      }
    ],
    nav: [
      {
        text: 'About',
        menu: [
          {
            text: 'Community',
            url: environmentURLs.REACT_APP_NAV_DEVELOPER_COMMUNITY_URL
          },
          {
            text: 'Marketplace',
            url: environmentURLs.REACT_APP_NAV_MARKETPLACE_URL
          }
        ]
      },
      {
        text: 'Documentation',
        menu: [
          {
            text: 'API Directory',
            url: environmentURLs.REACT_APP_NAV_DEVELOPER_APIS_URL
          },
          {
            text: 'Resources',
            url: environmentURLs.REACT_APP_NAV_DOCS_URL
          }
        ]
      },
      {
        text: 'Support',
        menu: [
          {
            text: 'Contact Us',
            url: environmentURLs.REACT_APP_CONTACT_US_URL
          },
          {
            text: 'Developer Forum',
            url: environmentURLs.REACT_APP_BLOG_URL
          }
        ]
      }
    ],
    copyright: {
      trademark: `©${new Date().getFullYear()} CDK Global, CDK Global is a trademark of CDK Global, LLC. This portal is for the use of CDK Global clients only, and such use is subject to such clients’ contracts with CDK.`
    }
  }
};
